module.exports = __webpack_public_path__ + "img/parliament-1.1b1f8e75.webp";